// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"320e9c01","513":"de7e1e44","703":"3e26388f","787":"28525a86"}[chunkId] + ".chunk.js";
};